import { forwardRef } from 'react';

import { IconProps } from '../';

export const TimelineHexagonIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" ref={ref} {...props} {...{ className }}>
      <g clipPath="url(#clip0_4003_40709)">
        <g filter="url(#filter0_d_4003_40709)">
          <path
            d="M9.26594 4.64036C9.68677 4.29835 10.3132 4.29836 10.7341 4.64037C11.4809 5.24733 12.729 6.14805 14.1554 6.71396C14.6278 6.9014 14.9378 7.37884 14.8955 7.88534C14.7632 9.47174 14.862 11.2927 14.9368 12.277C14.9697 12.7091 14.7335 13.1199 14.3457 13.3131C13.5263 13.7215 12.0555 14.5066 10.6244 15.5334C10.2521 15.8006 9.7479 15.8006 9.37558 15.5334C7.95298 14.5127 6.49114 13.7309 5.66892 13.3205C5.27435 13.1235 5.03677 12.7018 5.07275 12.2623C5.14859 11.336 5.23747 9.65002 5.08957 7.85975C5.0487 7.36504 5.35697 6.9058 5.81891 6.72411C7.25599 6.15887 8.51463 5.25096 9.26594 4.64036Z"
            fill="#FC65F1"
          />
          <path
            d="M8.63477 3.86426C9.42303 3.22363 10.577 3.22363 11.3652 3.86426C12.0766 4.44238 13.2337 5.27209 14.5244 5.78418C15.3873 6.12657 15.9722 7.00331 15.8916 7.96875C15.7661 9.47294 15.8597 11.2291 15.9336 12.2012C15.9976 13.0436 15.5393 13.8355 14.792 14.208C13.9969 14.6043 12.5776 15.3623 11.207 16.3457C10.4863 16.8627 9.51367 16.8627 8.79297 16.3457C7.43056 15.3682 6.02056 14.6131 5.22266 14.2148C4.46244 13.8354 4.00685 13.0274 4.07617 12.1807C4.14968 11.2828 4.23438 9.65689 4.09277 7.94238C4.01288 6.97527 4.6118 6.12486 5.45312 5.79395C6.75281 5.28274 7.91892 4.44601 8.63477 3.86426Z"
            fill="none"
            stroke="white"
            strokeWidth="2"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_4003_40709"
          x="1.06914"
          y="1.38379"
          width="17.8708"
          height="19.3501"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4003_40709" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4003_40709" result="shape" />
        </filter>
        <clipPath id="clip0_4003_40709">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
});

export default TimelineHexagonIcon;
